import { getScenarioBadge } from '../../utils/executionScenario'

/**
 * Badge dello scenario di esecuzione, identico in lista e in dettaglio.
 *
 * Non rende nulla quando la conversazione non ha un profilo: il percorso storico resta
 * visivamente quello di prima.
 *
 * @param {Object} props
 * @param {Object} props.conv - Conversazione con la descrizione pubblica `scenario`
 */
export function ScenarioBadge({ conv }) {
  const badge = getScenarioBadge(conv)
  if (!badge) return null
  return (
    <span className={`nora-status nora-status--${badge.variant}`} title={badge.title}>
      <span className="nora-status__dot" />
      <span className="nora-status__label">{badge.label}</span>
    </span>
  )
}
